export default "__VITE_ASSET__BgOblvrd__"